export const invitationClient = {
    namespaced: true
};
